export enum BloodPressureStatus {    
    NoProblems = 0,
    MaintainedByLifestyle = 1,
    MaintainedByMeds = 2,
    MaintainedByMultipleMeds = 3
}